import React, { Component } from 'react';
import UploadButton from './UploadButton';

export default class HeaderView extends Component {
  render () {
    const hidden = this.props.hiddenUpload ? 'hidden' : '';
    return (
      <header id="header">
        <div className="container header-frame">
          <div className="logo pull-left">
            <a href="http://cloudinary.com">
              {/*<img src="http://dev.cloudinary.com/res/demo/image/upload/fl_attachment/v1/logo/for_white_bg/cloudinary_logo_for_white_bg.svg" height="36" width="169" alt="cloudinary" />*/}
              <img src="https://res.cloudinary.com/cloudinary/image/upload/fl_attachment/v1/logo/for_white_bg/cloudinary_logo_for_white_bg.svg" height="36" width="169" alt="cloudinary" />
            </a>
          </div>
          <div className="signup-block pull-right">
            <a href="https://cloudinary.com/signup?source=demo" className="btn btn-sm btn-default">sign up <span className="hidden-xs">for free</span></a>
          </div>
          <div className={'btn-center text-center ' + hidden}>
            <UploadButton onResult={this.props.setCurrentImage}/>
          </div>
        </div>
      </header>
    );
  }
}


/** WEBPACK FOOTER **
 ** ./src/js/components/HeaderView.js
 **/